<app-alert></app-alert>
<router-outlet></router-outlet>
<app-loader></app-loader>
